import React, { useContext, useState } from "react";
import Sidebar from "../components/sidebar/Sidebar";
import { AuthContext } from "../context/AuthContext";
import Chat from "../components/sidebar/Chat";
import Modal from "../components/sidebar/Modal";
import { useEffect } from "react";
import { Navigate } from "react-router-dom";

export default function Home() {
  const [toggleGroup, setToggleGroup] = useState(false);
  const [members, setMembers] = useState([]);
  const { currentUser } = useContext(AuthContext);
  const groupHandler = () => {
    setToggleGroup(!toggleGroup);
  };
  useEffect(() => {
    if (!currentUser) {
      Navigate("/login");
    }
  }, [currentUser]);
  return (
    <div className="home">
      <div className="container">
        <Sidebar groupHandler={groupHandler} />
        <Chat members={members} />
      </div>
      {toggleGroup && (
        <Modal
          setToggleGroup={setToggleGroup}
          members={members}
          setMembers={setMembers}
        />
      )}
    </div>
  );
}
